export default __webpack_public_path__ + "static/media/paul_thumb500px.3bfb517f.jpg";